import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <section className="privacyPolicy py-5">
        <div className="container">
          <h1>Privacy Policy - DialGrid</h1>
          <p>
            <strong>Effective Date:</strong> 03/05/2025
          </p>

          <p>
            At DialGrid, your privacy is our priority. As an AI-powered IVR (Interactive Voice
            Response) solution, we are committed to protecting the personal information of both our
            business clients and the end-users (callers) they serve. This Privacy Policy explains
            how we collect, use, store, and share information through our voice and AI technologies.
          </p>

          <h2 className="mt-4 mb-3">1. Who We Are</h2>
          <p>
            DialGrid is a next-generation AI IVR platform designed to answer and manage calls using
            natural-sounding AI agents. Our technology supports high call volumes, multilingual
            responses, and real-time analytics to help businesses enhance customer experiences.
          </p>

          <h2 className="mt-4 mb-3">2. Information We Collect</h2>
          <table className="table table-bordered">
            <thead>
              <tr className="table-success">
                <th>Category</th>
                <th>Types of Data Collected</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Caller & User Data</td>
                <td>
                  Phone numbers and caller ID
                  <br />
                  Call audio recordings and transcripts
                  <br />
                  Language and sentiment analysis data
                  <br />
                  Interaction data with AI agents
                  <br />
                  Call routing and transfer history
                </td>
              </tr>
              <tr>
                <td>Business Client Data</td>
                <td>
                  Business information used to train AI
                  <br />
                  Voice preferences, languages, and routing settings
                  <br />
                  User and admin account details (name, email, login activity)
                </td>
              </tr>
              <tr>
                <td>System & Technical Data</td>
                <td>
                  IP addresses and device/browser information
                  <br />
                  Usage logs, timestamps, and analytics data
                </td>
              </tr>
            </tbody>
          </table>

          <h2 className="mt-4 mb-3">3. How We Use Information</h2>
          <ul>
            <li>AI call handling and routing</li>
            <li>Training and improving voice agent performance</li>
            <li>Real-time sentiment and upsell suggestions</li>
            <li>Analytics and performance insights</li>
            <li>Compliance and quality assurance</li>
          </ul>

          <h2 className="mt-4 mb-3">4. Call Recording and Transcription</h2>
          <p>
            Calls may be recorded and transcribed for improving AI models, supporting agent
            transfers, and meeting compliance standards. Caller notification is provided where
            legally required.
          </p>

          <h2 className="mt-4 mb-3">5. Data Sharing and Disclosure</h2>
          <p>We only share data with authorized parties such as:</p>
          <ul>
            <li>Human agents for escalated support</li>
            <li>Trusted service providers under contract</li>
            <li>Authorities if required by law</li>
          </ul>

          <h2 className="mt-4 mb-3">6. Data Security</h2>
          <p>We use encryption, access control, audits, and segregation to protect your data.</p>

          <h2 className="mt-4 mb-3">7. International Use and Language Support</h2>
          <p>
            DialGrid supports over 50 languages and complies with global data protection laws
            including GDPR and CCPA.
          </p>

          <h2 className="mt-4 mb-3">8. Data Retention</h2>
          <p>
            Data is retained only as long as needed for service delivery, legal obligations, or
            client contracts.
          </p>

          <h2 className="mt-4 mb-3">9. HIPAA Compliance</h2>
          <p>
            DialGrid does not require access to PHI but may store PHI in “data at rest” (e.g.,
            voicemail, recordings). All PHI is encrypted and access-controlled in accordance with
            HIPAA and HITECH rules.
          </p>

          <h2 className="mt-4 mb-3">
            10. How to Review, Update, Correct, or Delete Personal Information
          </h2>
          <p>
            To review, update, or delete your personal information, email{" "}
            <strong>info@dialgrid.com</strong> with proof of identity including:
          </p>
          <ul>
            <li>Full name, address, and zip code</li>
            <li>User ID and password (if applicable)</li>
            <li>Recent account activity details</li>
          </ul>
          <p>
            We may deny requests if identity cannot be verified or if rights of others would be
            violated. An explanation will be provided in such cases.
          </p>

          <h2 className="mt-4 mb-3">11. Your Rights</h2>
          <p>
            Depending on your location, you may have rights to access, update, delete, or restrict
            processing of your data. Contact <strong>info@dialgrid.com</strong>.
          </p>

          <h2 className="mt-4 mb-3">12. Children's Privacy</h2>
          <p>
            DialGrid is not intended for children under 13. We do not knowingly collect data from
            children.
          </p>

          <h2 className="mt-4 mb-3">13. Changes to This Privacy Policy</h2>
          <p>
            We may update this policy from time to time. Changes will be posted on our website with
            the new effective date.
          </p>

          <h2 className="mt-4 mb-3">14. Contact Us</h2>
          <p>
            <strong>DialGrid Privacy Team</strong>
            <br />
            Email: <strong>info@dialgrid.com</strong>
            <br />
            Website: <strong>www.dialgrid.ai</strong>
          </p>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
